import { useEffect, useRef, useState } from "react";
import MessagesContainer from "../../../../messages/messageContainer";
import useGetOrderItemInrixVolumeParams, {
  InrixVolumeTimePeriod,
} from "../controls/GetOrderItemInrixVolumeParams";

const getInrixVolumeMessage = ({
  timePeriod,
  dayOfWeekInUrl,
  timeSegment,
  selectedValue,
}: {
  timePeriod: InrixVolumeTimePeriod;
  dayOfWeekInUrl: string | null;
  timeSegment: number | null;
  selectedValue: number | null;
}) => {
  if (selectedValue !== null) {
    return "";
  }

  if (timePeriod === InrixVolumeTimePeriod.ADT) {
    return "Click road to see volume ADT";
  }

  if (dayOfWeekInUrl === null) {
    return "Choose a day and 15 min segment to see value";
  }

  if (timeSegment === null) {
    return "Choose a 15 minute segment to see value";
  }

  return "";
};

interface OrderItemInrixVolumesMessagesProps {}

const OrderItemInrixVolumesMessages =
  ({}: OrderItemInrixVolumesMessagesProps) => {
    const { timePeriod, dayOfWeekInUrl, timeSegment } =
      useGetOrderItemInrixVolumeParams();

    const [label, setLabel] = useState("");
    const [visible, setVisible] = useState(false);
    const labelTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
      if (labelTimerRef.current) clearTimeout(labelTimerRef.current);
      labelTimerRef.current = setTimeout(() => {
        setLabel(
          getInrixVolumeMessage({
            timePeriod,
            dayOfWeekInUrl,
            timeSegment,
            selectedValue: null,
          }),
        );
      }, 500);

      return () => {
        if (labelTimerRef.current) clearTimeout(labelTimerRef.current);
      };
    }, [timePeriod, dayOfWeekInUrl, timeSegment]);

    return (
      <>
        {label && visible && (
          <MessagesContainer>
            <div className="rounded bg-light text-black text-center p-2">
              {label}
            </div>
          </MessagesContainer>
        )}
      </>
    );
  };

export default OrderItemInrixVolumesMessages;
